import { useContext, useState } from "react";
import { styled } from "@mui/material/styles";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import Typography from "@mui/material/Typography";
import { StreamContext } from "contexts/Stream";

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  zIndex: 1300,
  "& .MuiPaper-root": {
    backgroundColor: "rgba(0, 0, 0, 0.2)",
    padding: 15,
    borderRadius: 12,

    [theme.breakpoints.down("md")]: {
      top: "-150px",
    },
  },
  "& .MuiDialogContent-root": {
    padding: theme.spacing(2),
  },
  "& .MuiDialogActions-root": {
    padding: theme.spacing(1),
  },
}));

export default function StreamingNotAvailablePopup() {
  const { setStreamingState } = useContext(StreamContext);
  const [open, setOpen] = useState(true);
  const handleClose = () => {
    setStreamingState((prev) => ({
      ...prev,
      callStreamingAvailableAPI: true,
      streamingNotAvailable: false,
    }));

    setOpen(false);
  };

  return (
    <BootstrapDialog onClose={handleClose} aria-labelledby="customized-dialog-title" open={open}>
      <DialogTitle
        sx={{ m: 0, p: 2, color: "#fff", fontWeight: 900, fontSize: 16 }}
        id="customized-dialog-title"
      >
        3D LIVE STREAM IS NOT AVAILABLE
      </DialogTitle>
      <IconButton
        aria-label="close"
        onClick={handleClose}
        sx={{
          position: "absolute",
          right: 8,
          top: 8,
          color: (theme) => theme.palette.grey[100],
        }}
      >
        <CloseIcon />
      </IconButton>

      <DialogContent sx={{ color: (theme) => theme.palette.grey[900] }}>
        <Typography color="#fff" variant="body1" gutterBottom>
          Currently, live stream is not available as all the stream seats are occupied. We will
          notify you once Live Stream is available.
        </Typography>
      </DialogContent>
    </BootstrapDialog>
  );
}
